export default __webpack_public_path__ + "035d8a428c4eb0e59ffcde589df96b42.svg";